// extracted by mini-css-extract-plugin
module.exports = {"motoTextContainer":"moto-text-module--moto-text-container--3dHRB","motoText":"moto-text-module--moto-text--1UYo4"};